import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

const hospitalDialog = [
  new Dialog(
    "SONNY YANG: Ohh my head…",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-14-Sonny2-MP3.mp3")
  ),
  new Dialog(
    "DOCTOR: Oh good, you’re awake Sonny Yang.",
    require("@/images/Doctor.png"),
    require("@/audio/Pandemic-14-Doctor1-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: What happened ?",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-14-Sonny3-MP3.mp3")
  ),
  new Dialog(
    "DOCTOR: You were knocked out by a rival shopper at the store. This pandemic is driving people crazier and crazier.",
    require("@/images//Doctor.png"),
    require("@/audio/Pandemic-14-Doctor2-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: Dareth Schamren! Wait a minute, what happened to my supplies ?",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-14-Sonny4-MP3.mp3")
  ),
  new Dialog(
    "DOCTOR: I’m sorry to say that it seems your assailant also made off with your groceries. Bought and paid for them and everything.",
    require("@/images/Doctor.png"),
    require("@/audio/Pandemic-14-Doctor3-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: This is an injustice of the highest order. Those groceries are rightfully mine. Looks like I’ll have to pay Dareth Schamren a little visit…",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-14-Sonny5-MP3.mp3")
  ),
  new Dialog(
    "DOCTOR: Whatever you do, I would urge you to avoid getting into any more medical trouble Sonny Yang. We’re almost at maximum capacity here with the increasing influx of YOGID - infected patients so please, try not to clog up the health care system okay ?",
    require("@/images/Doctor.png"),
    require("@/audio/Pandemic-14-Doctor4-MP3.mp3")
  ),
];

export class IntroHospital extends Scene {
  title = "Emergency Room";
  async init() {
    await this.dialogRunner(hospitalDialog)
    await this.navigate(scenes.HospitalExterior())
  }
}

export default new IntroHospital();
